export const primary = {
  50: 'rgb(255, 246, 253)',
  100: 'rgb(255, 238, 249)',
  150: 'rgb(254, 230, 246)',
  200: 'rgb(253, 222, 242)',
  250: 'rgb(251, 212, 239)',
  300: 'rgb(249, 201, 235)',
  350: 'rgb(247, 191, 233)',
  400: 'rgb(244, 181, 230)',
  450: 'rgb(239, 150, 218)',
  500: 'rgb(233, 117, 204)',
  550: 'rgb(225, 80, 190)',
  600: 'rgb(217, 18, 174)',
  650: 'rgb(187, 12, 148)',
  700: 'rgb(157, 6, 123)',
  750: 'rgb(129, 2, 100)',
  800: 'rgb(101, 0, 77)',
  850: 'rgb(77, 0, 58)',
  900: 'rgb(55, 0, 40)',
  950: 'rgb(34, 0, 23)',
}
export const accent = {
  50: 'rgb(255, 250, 246)',
  100: 'rgb(255, 246, 238)',
  150: 'rgb(254, 241, 231)',
  200: 'rgb(253, 237, 223)',
  250: 'rgb(254, 229, 206)',
  300: 'rgb(255, 221, 189)',
  350: 'rgb(255, 214, 171)',
  400: 'rgb(255, 206, 153)',
  450: 'rgb(253, 182, 120)',
  500: 'rgb(251, 157, 88)',
  550: 'rgb(247, 129, 57)',
  600: 'rgb(243, 99, 27)',
  650: 'rgb(219, 81, 21)',
  700: 'rgb(195, 63, 14)',
  750: 'rgb(171, 46, 6)',
  800: 'rgb(148, 27, 0)',
  850: 'rgb(115, 15, 0)',
  900: 'rgb(83, 4, 0)',
  950: 'rgb(53, 0, 0)',
}
export const grey = {
  50: 'rgb(250, 250, 250)',
  100: 'rgb(245, 245, 245)',
  150: 'rgb(240, 240, 240)',
  200: 'rgb(235, 235, 235)',
  250: 'rgb(227, 229, 230)',
  300: 'rgb(220, 223, 224)',
  350: 'rgb(212, 217, 219)',
  400: 'rgb(205, 211, 214)',
  450: 'rgb(170, 176, 180)',
  500: 'rgb(136, 143, 146)',
  550: 'rgb(104, 111, 114)',
  600: 'rgb(73, 80, 84)',
  650: 'rgb(63, 69, 73)',
  700: 'rgb(53, 59, 63)',
  750: 'rgb(43, 49, 53)',
  800: 'rgb(34, 39, 43)',
  850: 'rgb(24, 28, 31)',
  900: 'rgb(14, 17, 19)',
  950: 'rgb(5, 7, 9)',
}
